export default {
  unavailable: {
    title: 'Asiakaslaskut eivät ole käytettävissä',
    description:
      'Ravintoloissasi tilaavat asiakkaat eivät voi pyytää laskua, joten täällä ei ole mitään asetettavaa. Tilauskuitit ja palveluntarjoajasi sinulle lähettämät laskut eivät muutu.',
  },
};
